var _defs, _polygon, _polygon2, _polygon3, _g, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSensorFatiga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#GradientFill_3-9);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3-8);\n      }\n\n      .cls-3 {\n        fill: url(#GradientFill_3-4);\n      }\n\n      .cls-4 {\n        fill: url(#GradientFill_3-5);\n      }\n\n      .cls-5 {\n        fill: url(#GradientFill_3-7);\n      }\n\n      .cls-6 {\n        fill: url(#GradientFill_3-6);\n      }\n\n      .cls-7 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-8 {\n        fill: url(#GradientFill_3-3);\n      }\n\n      .cls-9 {\n        fill: url(#GradientFill_3);\n      }\n\n      .cls-10 {\n        fill: url(#GradientFill_3-10);\n      }\n\n      .cls-11 {\n        fill: url(#GradientFill_3-11);\n      }\n\n      .cls-12 {\n        fill: url(#GradientFill_3-12);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25.44,
    y1: 49.96,
    x2: 25.44,
    y2: 0.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 28.04,
    y1: 49.96,
    x2: 28.04,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-3",
    "data-name": "GradientFill 3",
    x1: 30.93,
    y1: 49.96,
    x2: 30.93,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-4",
    "data-name": "GradientFill 3",
    x1: 36.1,
    y1: 49.96,
    x2: 36.1,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-5",
    "data-name": "GradientFill 3",
    x1: 40.15,
    y1: 49.96,
    x2: 40.15,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-6",
    "data-name": "GradientFill 3",
    x1: 36.98,
    y1: 49.96,
    x2: 36.98,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-7",
    "data-name": "GradientFill 3",
    x1: 37.87,
    y1: 49.96,
    x2: 37.87,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-8",
    "data-name": "GradientFill 3",
    x1: 27.53,
    x2: 27.53,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-9",
    "data-name": "GradientFill 3",
    x1: 20.06,
    x2: 20.06,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-10",
    "data-name": "GradientFill 3",
    x1: 18.21,
    y1: 49.96,
    x2: 18.21,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-11",
    "data-name": "GradientFill 3",
    x1: 13.88,
    y1: 49.96,
    x2: 13.88,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-12",
    "data-name": "GradientFill 3",
    x1: 25,
    x2: 25,
    xlinkHref: "#GradientFill_3"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "26.26 11.46 25.38 11.58 26.38 9.69 26.45 9.11 24.68 9.34 24.61 10.04 25.44 9.93 24.44 11.81 24.44 12.39 26.21 12.11 26.26 11.46"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "29.04 11.16 28.04 11.34 29.22 9.11 29.22 8.4 27.15 8.7 27.1 9.53 28.04 9.4 26.92 11.64 26.87 12.28 29.04 11.99 29.04 11.16"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "32.05 10.88 30.86 11.04 32.23 8.53 32.28 7.77 29.92 8.11 29.86 8.99 30.93 8.88 29.62 11.34 29.57 12.11 31.98 11.76 32.05 10.88"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.88,17.8c-.52-1-.59-2.06-.35-3.11.3-1.06,1-1.93,1.89-2.53l-.3-.52c-1.06.64-1.82,1.7-2.17,2.86-.3,1.23-.18,2.48.42,3.6l.52-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.35,16.22l-.52,1.93c.05.07.12.12.17.12h.23l1.54-.88,1.89.24c.07.06.12,0,.19,0,0-.05.05-.05.05-.12l.58-2.05c0-.07,0-.12-.05-.18,0-.05-.07-.05-.12-.12l-1.77-.7-.82-1.53c-.07-.05-.12-.12-.25-.12-.05,0-.12,0-.23.07l-.52,1.93c-.18.19-.3.42-.37.65-.12.23-.12.53,0,.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.11,14.87c-.29.86-.17,1.81.25,2.63l.52-.28c-.35-.72-.4-1.48-.23-2.23.23-.72.7-1.41,1.35-1.83l-.28-.53c-.83.53-1.36,1.3-1.6,2.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.23,15.15c-.17.58-.12,1.18.12,1.76l.53-.3c-.17-.4-.23-.88-.12-1.28.18-.46.42-.88.83-1.18l-.3-.46c-.54.3-.95.81-1.07,1.46"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.63,30.25c-.12-.18-.23-.35-.35-.53-.47-.58-1.17-.93-1.94-.93h-6.13l-4.43,4-.12.11h-.05c.59.58,1.47.86,2.36.75h8.26l3.76,7.94c.25.4.6.77,1.07.93.42.18.93.12,1.35-.05.47-.25.77-.6.95-1.06.17-.42.12-.93-.07-1.35l-4.66-9.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.42,35.06q.07-.05.12-.12h.35v.07q.06,0,.06.05l1.24,1.65,1.24-1.65c.07-.05.12-.12.23-.12.06-.05.18,0,.23.07,0,0,.06,0,.06.05l1.24,1.65,1.24-1.65s.12-.12.18-.12c.12-.05.17,0,.23.07q.05,0,.12.05l1.17,1.65,1.24-1.65c.07-.05.18-.12.23-.12.07-.05.18,0,.25.07,0,0,.05,0,.05.05l1.54,2c0,.06.05.12.05.23-.05.06-.05.18-.17.18-.07.05-.12.12-.23.12-.07-.06-.18-.12-.18-.18l-1.24-1.65-1.24,1.65-.06.07-.05.05c-.07,0-.12.06-.12.06h-.06c-.05,0-.05-.06-.12-.06l-.05-.05h-.07v-.07l-1.24-1.65-1.24,1.65v.07h-.07v.05h-.05c-.07,0-.07.06-.12.06-.07,0-.12-.06-.18-.06l-.05-.05-.07-.07-1.17-1.65-1.23,1.65-.07.07-.05.05c-.07,0-.14.06-.18.06-.07,0-.07-.06-.12-.06h-.07v-.05h-.05v-.07l-1.24-1.58v-.07l-1.23,1.65c-.07.07-.12.12-.24.18-.06,0-.13-.06-.25-.12-.05,0-.12-.12-.12-.18,0-.12,0-.17.07-.23l1.47-2ZM17,32.48l-3.06-13.51c-.07-.47-.35-.86-.77-1.11-.42-.23-.89-.35-1.36-.23-.47.11-.89.41-1.19.83-.23.35-.28.88-.23,1.35l3.78,16.73c.07.42.3.77.59,1.06.37.24.77.4,1.19.4h11.97c.47,0,.94-.23,1.3-.51.29-.35.52-.83.52-1.3s-.24-.93-.52-1.28c-.37-.3-.83-.53-1.3-.53h-10.5l-.05-.3,1.24-1.17c-.37-.36-.6-.77-.72-1.25l-.89.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M18.24,15.99c.95,0,1.84-.37,2.49-1,.64-.72,1.05-1.6,1.05-2.53s-.42-1.81-1.05-2.46c-.65-.72-1.54-1.06-2.49-1.06s-1.87.35-2.53,1.06c-.65.65-1.07,1.52-1.07,2.46s.42,1.81,1.07,2.53c.65.63,1.59,1,2.53,1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M15.13,19.15c.12-.53.28-1,.64-1.35l-2.53-2.41c-.18-.11-.37-.16-.53-.16-.19,0-.35.05-.47.16-.12.19-.23.35-.23.54.05.18.12.35.23.46l2.89,2.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3.06,25C3.06,12.95,12.9,3.15,25,3.15c10.21,0,18.81,6.97,21.25,16.38-1.01-.42-1.93-.79-2.23-.92-.42-.12-.82-.28-1.24-.4-.42-.11-.82-.18-1.31-.23-.4-.07-.82-.07-1.23,0-.35.05-.77.16-1.05.35-.35.16-.65.46-.89.76-.18.16-.3.4-.35.58-.12.23-.19.46-.24.76-.23,1-.48,2-.72,2.99l-3.41-1.18,1.12-3.05c.05-.25.05-.53-.07-.71-.05-.23-.28-.4-.54-.46-.23-.12-.47-.12-.7,0-.24.12-.42.3-.47.53l-1.35,3.69c-.18-.46-.54-.88-1-1.05l-10.96-4c-.49-.23-1.07-.3-1.66-.18l-.42.11c-.7.12-1.29.53-1.71,1.12-.35.58-.54,1.35-.35,2l2.41,11.33.06.05,4.9-4.46-1.19-5.34,7.61,2.76c.54.18,1.07.18,1.54-.12l-.89,2.41c-.11.24-.11.52,0,.77.12.17.3.35.54.47.23.05.52.05.7-.06.23-.12.42-.28.54-.52l1.12-3.18,3.83,1.3-.23,1.35c-.05.4-.12.76-.18,1.16-.05.23-.12.48-.12.71,0,.05,0,.12.06.17,0,.07,0,.12.05.18.07.05.13.12.25.17.05,0,.17.06.29.11.42.25.88.53,1.23.89.42.41.77.83,1.07,1.23.65,1,1.12,2.06,1.29,3.25.18,1.23.12,2.51-.29,3.75-.18.65-.47,1.3-.83,1.95-.12.23-.65,1.05-1.34,2.07-3.62,2.63-8.08,4.19-12.9,4.19-12.1,0-21.94-9.8-21.94-21.85M25,.11C11.22.11,0,11.28,0,25s11.22,24.89,25,24.89,25-11.17,25-24.89S38.78.11,25,.11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSensorFatiga);
export default __webpack_public_path__ + "static/media/Icon_SensorFatiga.5c70b63ab8aa30d206a3a3212b43bbff.svg";
export { ForwardRef as ReactComponent };